import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

import PaymentStatistics from 'PMT/entities/PaymentStatistics';

import CurrencyUtils from 'PMT/utils/CurrencyUtils';

/**
 * Display payment statistic key numbers.
 */
class PaymentStatsKeyNumbers extends Component {

  static propTypes = {
    paymentStatistics: PropTypes.instanceOf(PaymentStatistics),
    currencyCode: PropTypes.string,

  };

  componentDidMount() {
    // -- bootstrap tooltip
    $('body').tooltip({
      selector: '[data-toggle="tooltip"]'
    });
  }

  render() {
    const paymentStatistics: PaymentStatistics = this.props.paymentStatistics;
    const tipsDetailView = [];
    const currencyCode = this.props.currencyCode;

    if (!_.isEmpty(paymentStatistics.tips)) {
      let i = 0;
      _.forEach(paymentStatistics.tips, (tip) => {
        if (tip.tips !== 0) {
          let waiterName = tip.waiterName;

          if (waiterName === 'null null'
          || _.isEmpty(waiterName)) {
            waiterName = 'Non renseigné';
          }

          tipsDetailView.push(
            <li key={i}>
              <span
                className="payment_stats_key_numbers__tip_name"
              >
                {waiterName}
              </span>
              <span
                className="payment_stats_key_numbers__tip_value"
              >
                {CurrencyUtils.formatPriceWithCurrency(tip.tips, currencyCode)}
              </span>
            </li>
          );
          ++i;
        }
      });
    }

    return (
      <div className="payment_stats_key_numbers">

        <h2>{I18n.tr('payment_stats.numbers.key_numbers_title')}</h2>

        <div className="row top-buffer-40">

          <div className="col-xs-12 col-sm-6 col-lg-3">
            <span className="payment_stats_key_numbers__stat_title">
              {I18n.tr('payment_stats.numbers.payed_tables')}&nbsp;
              <sup>
                <i
                  className="glyphicon glyphicon-question-sign"
                  data-toggle="tooltip"
                  data-placement="top"
                  title={I18n.tr('payment_stats.numbers.payed_tables_tooltip')}
                />
              </sup>
            </span>
            <span className="payment_stats_key_numbers__stat_value">
              {paymentStatistics.checksNumber}
            </span>
          </div>

          <div className="col-xs-12 col-sm-6 col-lg-4">
            <span className="payment_stats_key_numbers__stat_title">
              {I18n.tr('payment_stats.numbers.number_of_payments')}&nbsp;
              <sup>
                <i
                  className="glyphicon glyphicon-question-sign"
                  data-toggle="tooltip"
                  data-placement="top"
                  title={I18n.tr('payment_stats.numbers.number_of_payments_tooltip')}
                />
              </sup>
            </span>
            <span className="payment_stats_key_numbers__stat_value">
              {paymentStatistics.paymentsNumber}
            </span>
          </div>

          <div className="col-xs-12 col-sm-6 col-lg-4">
            <span className="payment_stats_key_numbers__stat_title">
              {I18n.tr('payment_stats.numbers.amount_payed_with_pmt')}&nbsp;
              <sup>
                <i
                  className="glyphicon glyphicon-question-sign"
                  data-toggle="tooltip"
                  data-placement="top"
                  title={I18n.tr('payment_stats.numbers.amount_payed_with_pmt_tooltip')}
                />
              </sup>
            </span>
            <span className="payment_stats_key_numbers__stat_value">
              {CurrencyUtils.formatPriceWithCurrency(
                  paymentStatistics.totalAmountPaid, currencyCode)}
            </span>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">

            <div className="row payment_stats_key_numbers__tip">
              <div className="col-xs-12 col-md-3">
                <span className="payment_stats_key_numbers__stat_title">
                  {I18n.tr('payment_stats.numbers.tips')}
                </span>
                <span className="payment_stats_key_numbers__stat_value">
                  {CurrencyUtils.formatPriceWithCurrency(
                      paymentStatistics.totalTipsPaid, currencyCode)}
                </span>
              </div>

              <div className="col-xs-12 col-md-9">
                <ul className="payment_stats_key_numbers__tip_list">
                  {tipsDetailView}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

export default PaymentStatsKeyNumbers;
